import peoples from "../images/peoples.png";
import search from "../images/search.png";
import message from "../images/message.png";
import sent from "../images/sent.png";

// Copy blocks shown only on the VITE EN VOGUE channel. The wording is fixed
// German, exactly as it was in the templates these replace.
export function ViteHero() {
  return (
    <div className="gr-10 hero-header gr-8@tablet gr-12@mobile push-2@tablet push-1@desktop">
      <h2 className="hero-title">Retourenportal</h2>
      <p className="hero-content gr-10 gr-8@tablet gr-12@mobile push-2@tablet push-1@desktop">
        Bitte gib Deine E-Mail-Adresse und Bestellnummer ein, um Artikel einfach zurückzusenden.
        <br />
        Die Bestellnummer findest Du in der E-Mail mit Deiner digitalen Rechnung.
      </p>
    </div>
  );
}

const PROCESS = [
  {
    img: search,
    title: "Retoure anmelden",
    body: "Erstelle in unserem Retourenportal ein Rücksendeetikett und drucke dieses aus",
  },
  {
    img: message,
    title: "Rücksendeetikett ausdrucken",
    body: "Sende den Artikel im gleichen Zustand zurück, in dem Du ihn erhalten hast",
  },
  {
    img: sent,
    title: "30 Tage Rückgaberecht (2,99 €)",
    body: "Probiere Deine Einkäufe bequem zu Hause bis zu 30 Tage lang aus. Wenn Du mit ihnen nicht zufrieden bist, kannst Du sie für nur 2,99 € zurücksenden.",
  },
];

export function ViteReturnProcess() {
  return (
    <div className="gr-12 return-process">
      <h3 className="return-process-title">So funktioniert’s</h3>
      <div className="return-process-container">
        {PROCESS.map((step) => (
          <div className="return-process-box" key={step.title}>
            <div className="return-process-box-icon">
              <img src={step.img} alt={step.title} />
            </div>
            <h4 className="return-process-box-title">{step.title}</h4>
            <div className="return-process-box-content">{step.body}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ViteQa() {
  return (
    <div className="gr-10 gr-8@tablet gr-12@mobile push-2@tablet push-1@desktop">
      <div className="row qa-container">
        <div className="gr-6 qa-box-left gr-6@tablet gr-12@mobile">
          <div className="qa-box-icon">
            <img src={peoples} alt="Du hast noch Fragen?" />
          </div>
          <h4 className="qa-box-title">Du hast noch Fragen?</h4>
          <div className="qa-box-content">
            Dann wende Dich an unseren Kundenservice <br />
            und schicke uns eine E-Mail.
          </div>
        </div>
        <div className="gr-6 qa-box-right gr-6@tablet gr-12@mobile">
          <div className="qa-box-button">
            <a
              href="https://www.buddyandselly.com/de-de/service/hilfe-kontakt"
              target="_blank"
              rel="noopener noreferrer"
              className="button-primary-invert btn-contact"
            >
              Hilfe &amp; Kontakt
            </a>
          </div>
          <div className="qa-box-content">
            Nimm Kontakt zu uns auf, damit wir Dich persönlich bei all Deinen Anliegen unterstützen
            können.
          </div>
        </div>
      </div>
    </div>
  );
}
